import { Download } from "./images/Download"
import { Switch } from "./images/Switch"

export const variantConfig = {
  subscription: {
    Icon: Switch,
    altText: "переключатель",
    buttonText: "Оформить",
  },
  download: {
    Icon: Download,
    altText: "загрузка",
    buttonText: "Скачать",
  },
} as const
